import React, { Component, Fragment } from "react"
import { isEmpty } from "lodash"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
import { connect } from "react-redux"
import styles from "./styles"
import MainAppBar from "../../components/MainAppBar"
import { Typography, Hidden, Fab } from "@material-ui/core"
import {
  toggleAddClientDialog,
  toggleAddClientCompanyDialog,
  _setEditClientCompany,
  _setEditClient,
  setClients,
  toggleDeleteClientCompanyDialog,
} from "../../actions/clients"
import { getClientList, getClientCompanies } from "../../actions/clients"
import TabBar from "../../components/TabBar"
import LoadingIndicator from "../../components/LoadingIndicator"
import "@fullcalendar/daygrid/main.css"
import ClientActionBar from "../../components/ClientActionBar/index"
import ClientsTable from "../../components/ClientsTable/index"
import CompaniesTable from "../../components/CompaniesTable/index"
import AddClientDialog from "../../components/AddClientDialog/index"
import AddClientCompanyDialog from "../../components/AddClientCompanyDialog/index"

import DeleteClientDialog from "../../components/DeleteClientDialog/index"
import DeleteClientCompanyDialog from "../../components/DeleteClientCompanyDialog/index"

import AddIcon from "@material-ui/icons/Add"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import { getCurrentHost } from "../../utils/getHost"

class Clients extends Component {
  state = {
    searchKey: false,
    search: "",
    sort: null,
    creatorFilters: [],
    filters: [],
    showDialog: false,
    creatorsAnd: false,
    and: false,
    dateFilter: null,
    startDate: null,
    endDate: null,
    creatorFilter: null,
    showCreatorFilterDialog: false,
    loading: false,
    popover: {
      func: () => "",
      anchor: null,
    },
    crewShoots: [],
    isCalendarView: false,
    eventPopoverEl: null,
    eventPopoverShoot: null,
    currentPage: 1,
    flag: 1,
    sort_shoots: false,
    height: null,
    eventPopoverPosition: {
      top: 0,
      left: 0,
    },
    dateSetStrDate: null,
    dateSetEndDate: null,
    minDateSetStrTime: null,
    maxDateSetEndTime: null,
    searchTimeout: null,
    tab: 0,
  }

  componentWillMount() {
    this.loadClientList()
  }

  loadClientList = () => {
    this.setState({ loading: true })
    return Promise.all([
      this.props.dispatch(getClientList()),
      this.props.dispatch(getClientCompanies()),
    ])
      .then(res => {
        // console.log(res)
        this.setState({ loading: false })
      })
      .catch(err => {
        this.setState({ loading: false })
      })
  }

  openClientProfile(client) {
    const { tab } = this.state
    if (tab === 0) {
      this.props.dispatch(_setEditClient(client))
      this.props.dispatch(toggleAddClientDialog(true))
    }
    if (tab === 1) {
      this.props.dispatch(_setEditClientCompany(client))
      this.props.dispatch(toggleAddClientCompanyDialog(true))
    }
  }

  componentWillUnmount() {
    this.props.dispatch(setClients())
  }

  changeActiveTab = async value => {
    this.setState({ tab: value })
  }

  deleteClient = async cl => {
    await this.props.dispatch(_setEditClientCompany(cl))
    await this.props.dispatch(toggleDeleteClientCompanyDialog(true))
  }

  render() {
    const { props } = this
    const {
      clientList,
      searchedClientList,
      accessLevel,
      companyList,
      searchedClientCompaniesList,
    } = props

    return (
      <Fragment>
        {getCurrentHost() === "crewmama" ? (
          <CrewMamaAppBarComponent history={this.props.history} />
        ) : (
          <Fragment>
            <MainAppBar />
            <TabBar history={this.props.history} />
          </Fragment>
        )}
        <div className="page">
          <ClientActionBar
            history={this.props.history}
            onChange={this.handleActionBarChange}
            changeActiveTab={tab => this.changeActiveTab(tab)}
            activeFilters={this.state.activeFilters}
            sortDescending={this.state.desc}
            tab={this.state.tab}
            prop={this.props}
          />
        </div>
        <div>
          {this.state.tab === 0 ? (
            <AddClientDialog />
          ) : (
            <AddClientCompanyDialog />
          )}
        </div>

        <div>
          {this.state.tab === 0 ? (
            <DeleteClientDialog />
          ) : (
            <DeleteClientCompanyDialog />
          )}
        </div>
        <Hidden smDown>
          <div className={this.props.classes.resultsWrapper}>
            <LoadingIndicator working={this.state.loading}>
              {this.state.tab === 0 ? "Loading Clients" : "Loading Companies"}
            </LoadingIndicator>

            {!isEmpty(clientList) && (
              <Typography
                variant="h6"
                className={this.props.classes.resultsNumber}
              >
                {this.state.tab === 0 && clientList.length + " Clients"}
                {this.state.tab === 1 && companyList.length + " Companies"}
              </Typography>
            )}
          </div>
        </Hidden>
        {!isEmpty(clientList) &&
          this.state.tab === 0 && (
            <ClientsTable
              openClientProfile={client => this.openClientProfile(client)}
              clientList={searchedClientList}
              companyList={companyList}
            />
          )}

        {!isEmpty(companyList) &&
          this.state.tab === 1 && (
            <CompaniesTable
              openClientProfile={client => this.openClientProfile(client)}
              clientList={searchedClientCompaniesList}
              deleteClient={client => this.deleteClient(client)}
            />
          )}
        {accessLevel === 1 && (
          <Hidden mdUp>
            {this.state.tab === 0 ? (
              <Fab
                color="primary"
                className={this.props.classes.legendButton}
                onClick={() => this.props.dispatch(toggleAddClientDialog(true))}
              >
                <AddIcon style={{ color: "white" }} />
              </Fab>
            ) : (
              <Fab
                color="primary"
                className={this.props.classes.legendButton}
                onClick={() =>
                  this.props.dispatch(toggleAddClientCompanyDialog(true))
                }
              >
                <AddIcon style={{ color: "white" }} />
              </Fab>
            )}
          </Hidden>
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    clientList: state.clients.clients,
    companyList: state.clients.companiesList,
    searchedClientList: state.clients.searchedClients,
    searchedClientCompaniesList: state.clients.searchedClientCompanies,
    users: state.misc.users,
    roles: state.misc.roles,
    shoots: state.shoots.shoots,
    activeCompany: state.companies.activeCompany,
    shootsLength: state.shoots.shootsLength,
    accessLevel: state.companies.accessLevel,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(Clients)
